import { nextTick, onMounted, onUnmounted, ref, type Ref, type ShallowRef } from 'vue'
import { useAutoRefresh } from '../useAutorefresh'

export const useNavHeightRefresher = (
  navWrapper: Ref<HTMLDivElement | undefined> | Readonly<ShallowRef<HTMLDivElement>>,
  defaultNavHeight = 107.3,
) => {
  const navHeight = ref(defaultNavHeight)
  const navHeightRefresher = useAutoRefresh(async () => {
    updateNavHeight()
  }, 1000)
  const updateNavHeight = async () => {
    await nextTick()
    navHeight.value = navWrapper.value?.offsetHeight ?? defaultNavHeight
  }

  onMounted(() => {
    window.addEventListener('resize', updateNavHeight)
    updateNavHeight()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateNavHeight)
  })

  return {
    navHeight,
    navHeightRefresher,
    updateNavHeight,
  }
}
